import React from 'react';
import Navbar from '../components/Navbar';
import HeroSection from '../components/HeroSection';
import AboutUs from '../components/AboutUs';
import AreasOfActivity from '../components/AreasOfActivity';
import AreasOfDifference from '../components/AreasOfDifference';
import Procedure from '../components/Procedure';
import Stats from '../components/Stats';
import ContactCTA from '../components/ContactCTA';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <HeroSection />
        <AboutUs />
        <AreasOfActivity />
        <AreasOfDifference />
        <Procedure />
        <Stats />
        <ContactCTA />
      </main>
      <Footer />
    </div>
  );
};

export default Home; 